import { createContext, useContext, useRef } from 'react'

const NavigationContext = createContext(null)

export function NavigationProvider({ children }) {
  // Ref (not state) so it's synchronous — must be set before navigate() is called
  const pendingRef = useRef(false)

  function authorize() {
    pendingRef.current = true
  }

  function consume() {
    const was = pendingRef.current
    pendingRef.current = false
    return was
  }

  return (
    <NavigationContext.Provider value={{ authorize, consume }}>
      {children}
    </NavigationContext.Provider>
  )
}

export function useNavigationGuard() {
  return useContext(NavigationContext)
}
